import { ReferentialTask } from '@/core/domain/referential/task/ReferentialTask.ts'
import {
  type ReferentialDomainEntity,
  ReferentialDomainSchema
} from '@/core/infrastructure/schemas/referential/domain/ReferentialDomainSchema.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'

export class ReferentialDomain {
  id: number
  title: string
  order: number
  tasks: ReferentialTask[]

  constructor(domain: ReferentialDomainEntity) {
    this.id = domain.id
    this.title = domain.title
    this.order = domain.order

    // Initialiser tasks comme un tableau vide par défaut
    this.tasks = []

    // Traitement sécurisé de la propriété tasks
    if (domain.tasks && Array.isArray(domain.tasks)) {
      try {
        this.tasks = domain.tasks.map((task) => ReferentialTask.create(task))
      } catch (error) {
        console.error('Erreur lors du traitement des tâches:', error)
        this.tasks = []
      }
    }
  }

  // Méthodes utilitaires
  public getSortedTasks(): ReferentialTask[] {
    return [...this.tasks].sort((a, b) => a.order - b.order)
  }

  public findTaskById(taskId: number): ReferentialTask | undefined {
    return this.tasks.find((task) => task.id === taskId)
  }

  public hasTask(taskId: number): boolean {
    return this.tasks.some((task) => task.id === taskId)
  }

  public static create(data: unknown): ReferentialDomain {
    return EntityValidator.validateAndCreate(
      ReferentialDomainSchema,
      data,
      ReferentialDomain,
      'ReferentialDomain'
    )
  }
}
